import React, {
  useState,
  useImperativeHandle,
  useEffect,
  forwardRef,
} from "react"
import Api from "../../../../_helpers/Api"

//images
import loader from "../../../../assets/img/loader.svg"
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import { trans } from "../../../../_providers/Translation"
import Skeleton from "react-loading-skeleton"
import NoDataFound from "@/components/partials/NoDataFound"

function CorrectQuantity(props, ref) {
  const [popup, setPopup] = useState({
    overlay: false,
    modal: false,
    id: null,
    data: null,
    loading: false,
    loadingFind: false,
  })

  const [validations, setValidations] = useState(null)

  useImperativeHandle(ref, () => ({
    show: (id) => {
      setPopup((prev) => ({
        ...prev,
        id,
        loading: false,
      }))
      handleShow()
    },
    hide: () => {
      handleHide()
    },
  }))

  // извлича текущите данни, за да се попълнят полетата
  useEffect(() => {
    if (popup.id) {
      setPopup((prev) => ({
        ...prev,
        loadingFind: true,
      }))

      Api.get(`storage/part-quantities?id=${popup.id}`)
        .then((res) => {
          setPopup((prev) => ({
            ...prev,
            data: res.data,
          }))
        })
        .finally(() => {
          setPopup((prev) => ({
            ...prev,
            loadingFind: false,
          }))
        })
    }
  }, [popup.id])

  const handleShow = () => {
    setPopup((prev) => ({
      ...prev,
      overlay: true,
    }))

    setTimeout(() => {
      setPopup((prev) => ({
        ...prev,
        overlay: true,
        modal: true,
      }))
    }, 50)
  }

  const handleHide = (e) => {
    e.preventDefault()

    setPopup((prev) => ({
      ...prev,
      modal: false,
      loading: false,
    }))

    setTimeout(() => {
      setPopup((prev) => ({
        ...prev,
        overlay: false,
        modal: false,
        id: null,
      }))
    }, 50)
  }

  const handleSave = (e) => {
    e.preventDefault()

    setPopup((prev) => ({
      ...prev,
      loading: true,
    }))

    setValidations(null)

    let url = "storage/part-quantities/correction"

    let data = new FormData(e.target)

    data.append("id", popup.id)

    Api.post(url, data)
      .then((res) => {
        props.handleRefresh()

        handleHide(e)

        document.getElementById("form").reset()
      })
      .catch((error) => {
        setPopup((prev) => ({
          ...prev,
          loading: false,
        }))

        let _err = error.response

        if (_err && _err.status && _err.status == 422) {
          for (let [input, err] of Object.entries(_err.data.errors)) {
            setValidations((prevState) => {
              return { ...prevState, [input]: true }
            })
          }
        }
      })
  }

  const handleInputChange = (e) => {
    let name = e.target.name
    let val = Number(e.target.value)

    setPopup((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: val,
      },
    }))
  }

  return (
    <div className={`${popup.overlay ? "visible" : ""} overlay`}>
      <form
        className={`${popup.modal ? "show" : ""} popup-primary large`}
        onSubmit={handleSave}
      >
        <div className="head-new">
          <img src={popupDefaultHeadImage} alt="icon" />
          <div className="texts">
            <h2>{trans('headings.correctQuantity')}</h2>
            <p>{trans('subheadings.addEditUniversal')}</p>
          </div>
          <span className="close" onClick={handleHide}></span>
        </div>
        {popup.loadingFind ? (
          <Skeleton height={50} count={3} />
        ) : !popup.data?.locations.length ? (
          <NoDataFound />
        ) : (
          <div className="table-scroller">
            <table>
              <thead>
                <tr>
                  <th>{trans('labels.storage')}</th>
                  <th>{trans('labels.quantity')}</th>
                </tr>
              </thead>
              <tbody>
                {(popup.data?.locations || []).map((l, i) => (
                  <tr key={l.storage_location_id}>
                    <td>{l.storage_name || "Неизвестен"}</td>
                    <td>
                      <input
                        hidden
                        type="hidden"
                        name={`corrections[${i}][storage_location_id]`}
                        value={l.storage_location_id}
                      />
                      <input
                        type="number"
                        defaultValue={l.quantity || 0}
                        name={`corrections[${i}][new_quantity]`}
                        className={
                          validations?.[`corrections.${i}.new_quantity`] ||
                          validations?.[`corrections.${i}.storage_location_id`]
                            ? "validate"
                            : ""
                        }
                      />
                    </td>
                  </tr>
                ))}
                <tr>
                  <td>
                    <b
                      style={{
                        fontFamily: "Inter Bold, sans-serif",
                      }}
                    >
                      {trans('random.totalInAll')}
                    </b>
                  </td>
                  <td
                    style={{
                      paddingLeft: "30px",
                    }}
                  >
                    <b
                      style={{
                        fontFamily: "Inter Bold, sans-serif",
                      }}
                    >
                      {popup.data ? popup.data.total_quantity : "0"}
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        <div className="footer align-right">
          {popup.loading ? (
            <img src={loader} alt="loading" />
          ) : !popup.loadingFind && popup.data?.locations.length ? (
            <>
              <button className="button" onClick={handleHide}>
                {trans("buttons.cancel")}
              </button>
              <button className="button button-primary" type="submit">
                {trans("buttons.save")}
              </button>
            </>
          ) : (
            <></>
          )}
        </div>
      </form>
    </div>
  )
}

export default forwardRef(CorrectQuantity)
